// global imports
import React, { useEffect, useState } from 'react';
import { withLocalize } from 'react-localize-redux';

import { useDispatch, useSelector } from 'react-redux';

// project imports
import { putSettingsRequest } from '../../../../store/actions/common_actions';

// project types imports
import { IState } from '../../../../store/reducers';

// local imports
import { Grid, InputLabel, makeStyles, StyleRules, Theme } from '@material-ui/core';
import GridItem from '../../../../components/Grid/GridItem';
import { StyledSwitch } from '../../../../components/StyledSwitch';
import { IStyleProps, PropsClasses } from '../../../../types/StyleProps';
import style from './styles';
import { Props, StateProps } from './types';

const useStyles = makeStyles<Theme, IStyleProps>(style as StyleRules);

const TransferDesc = (props: Props) => {
  const { translate } = props;
  const classes: PropsClasses = useStyles({} as IStyleProps);
  const dispatch = useDispatch();
  const bexioSettings = useSelector<IState, StateProps>(({ bexio: { settings } }) => settings);

  const [transferDesc, setTransferDesc] = useState(bexioSettings ? !bexioSettings.doNotStoreDescription : true);

  useEffect(() => {
    if (!bexioSettings) {
      return;
    }
    if (transferDesc === !bexioSettings.doNotStoreDescription) {
      return;
    }
    dispatch(putSettingsRequest({ system: 'bexio', data: { ...bexioSettings, doNotStoreDescription: !transferDesc } }));
  }, [transferDesc]);

  useEffect(() => {
    if (!bexioSettings) {
      return;
    }
    setTransferDesc(!bexioSettings.doNotStoreDescription);
  }, [bexioSettings]);

  const onChange = (ev: React.ChangeEvent) => {
    setTransferDesc(!transferDesc);
  };

  return (
    <Grid container={true}>
      <GridItem xs={4} className={classes.gridItem}>
        <InputLabel>{translate('bexio.transfer-desc')}</InputLabel>
      </GridItem>
      <GridItem xs={8} className={classes.gridItem}>
        <StyledSwitch checked={transferDesc} onChange={onChange} disabled={!bexioSettings} />
      </GridItem>
    </Grid>
  );
};

export default withLocalize(TransferDesc);
